import { ADDRESS } from './address'
import { TELEPHONE } from './telephone'

export const SIMPLE_CUSTOMER = {
  attributes: {
    birthdate: '',
    document1: '',
    document2: '',
    email: '',
    has_credit: true,
    name: '',
    addresses: [ADDRESS],
    telephones: [TELEPHONE, TELEPHONE],
  },
}
